import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import config from "../config";

const CartPage = () => {

  const {
    cart,
    removeFromCart,
    updateQty,
    clearCart
  } = useCart();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const getUnit = (item) => {

  const categoryId =
    item.categoryid ||
    item.CategoryId;

  return Number(categoryId) === 1
    ? "Crt"
    : "Qty";
};

  // =========================
  // TOTAL
  // =========================
  const total = cart.reduce((sum, item) => {

  const price = Number(
    item.price ||
    item.Price ||
    0
  );

  return sum + (price * item.qty);

}, 0);

  // =========================
  // PLACE ORDER
  // =========================
const placeOrder = async () => {

if (cart.length === 0) {
alert("🛒 Cart is empty");
return;
}

if (!token) {
alert("🔐 Please login first");
navigate("/login");
return;
}

try {


setLoading(true);

const orderItems = cart.map((item) => ({
  productId: item.id || item.Id,
  quantity: item.qty,
  carat: Number(item.carat || 1),
  price: Number(item.price || item.Price || 0)
}));

const res = await axios.post(
  `${config.API_BASE_URL}/api/orders`,
  {
    address: "Kolkata, India",
    items: orderItems
  },
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
);

const orderId =
  res.data.orderId ||
  res.data.orderid ||
  res.data.id;

let productLines = "";

cart.forEach((item) => {

  const name =
    item.name ||
    item.Name ||
    "Product";

  const price = Number(
    item.price ||
    item.Price ||
    0
  );

const unit = getUnit(item);

productLines +=
  `• ${name}\n` +
  `   ${unit}: ${item.qty}\n` +
  `   Rate: ₹${price}/${unit}\n` +
  `   Amount: ₹${(
    price * item.qty
  ).toFixed(2)}\n\n`;

});

const whatsappMessage =


`Namaste Tuli Ji 🙏

Order ID: ${orderId}

${productLines}
Total: ₹${total.toFixed(2)}

Please guide me regarding this order.`;


const whatsappUrl =
  `https://wa.me/916290140351?text=${encodeURIComponent(
    whatsappMessage
  )}`;

clearCart();

window.location.href = whatsappUrl;


} catch (err) {

```
console.error(
  "PLACE ORDER ERROR:",
  err
);

const msg =
  err.response?.data?.message ||
  err.response?.data?.error ||
  "❌ Failed to place order";

alert(msg);
```

} finally {

```
setLoading(false);
```

}
};


  return (

    <div style={styles.page}>

      <Header />

      <div style={styles.container}>

        {/* ========================= */}
        {/* HEADER */}
        {/* ========================= */}

        <div style={styles.topBar}>

          <div>

            <h1 style={styles.title}>
              🛒 Shopping Cart
            </h1>

            <p style={styles.subtitle}>
              Review your selected products
            </p>

          </div>

          <button
            style={styles.shopBtn}
            onClick={() => navigate("/products")}
          >
            ← Continue Shopping
          </button>

        </div>

        {/* ========================= */}
        {/* EMPTY CART */}
        {/* ========================= */}

        {cart.length === 0 ? (

          <div style={styles.emptyBox}>

            <h2>🛍 Your cart is empty</h2>

            <p>
              Add some products to continue shopping
            </p>

            <button
              style={styles.primaryBtn}
              onClick={() => navigate("/products")}
            >
              Browse Products
            </button>

          </div>

        ) : (

          <div
  style={{
    ...styles.layout,
    gridTemplateColumns:
      window.innerWidth <= 768
        ? "1fr"
        : "2fr 1fr"
  }}
>

            {/* ========================= */}
            {/* CART ITEMS */}
            {/* ========================= */}

            <div style={styles.left}>

              {cart.map((item) => {

                const id =
                  item.id || item.Id;

                const name =
                  item.name ||
                  item.Name;

                const image =
                  item.image ||
                  item.Image;

                const price = Number(
                  item.price ||
                  item.Price ||
                  0
                );

                return (

                  <div
                    key={id}
                    style={styles.card}
                  >

                    {/* IMAGE */}

                    <div style={styles.imageWrap}>

                      {image ? (

                        <img
                          src={`${config.API_BASE_URL}/uploads/${image}`}
                          alt={name}
                          style={styles.image}
                        />

                      ) : (

                        <div style={styles.noImage}>
                          No Image
                        </div>

                      )}

                    </div>

                    {/* INFO */}

                    <div style={styles.info}>

                      <h3 style={styles.productName}>
                        {name}
                      </h3>

                      <div style={styles.price}>
                      ₹{price.toFixed(2)} / {getUnit(item)}
                    </div>

                    <div
                      style={{
                        marginTop: 5,
                        fontSize: 14,
                        color: "#666"
                      }}
                    >
                      {getUnit(item)}: {item.qty} 
                    </div>

                      {/* QUANTITY */}

                      <div style={styles.qtyWrap}>

                        <button
                          style={styles.qtyBtn}
                          onClick={() =>
                            updateQty(
                              id,
                              item.qty - 1
                            )
                          }
                        >
                          −
                        </button>

                        <span style={styles.qtyText}>
                          {item.qty}
                        </span>

                        <button
                          style={styles.qtyBtn}
                          onClick={() =>
                            updateQty(
                              id,
                              item.qty + 1
                            )
                          }
                        >
                          +
                        </button>

                      </div>

                    </div>

                    {/* RIGHT */}

                    <div style={styles.rightBox}>

                      <div style={styles.subtotal}>
                        ₹{(
                            price *
                            item.qty
                          ).toFixed(2)}
                      </div>

                      <button
                        style={styles.removeBtn}
                        onClick={() =>
                          removeFromCart(id)
                        }
                      >
                        Remove
                      </button>

                    </div>

                  </div>
                );
              })}

            </div>

            {/* ========================= */}
            {/* ORDER SUMMARY */}
            {/* ========================= */}

            <div
  style={{
    ...styles.summary,
    width: "100%",
    boxSizing: "border-box"
  }}
>

              <h2 style={styles.summaryTitle}>
                Order Summary
              </h2>
              <h3>Amount and Item color may change based on actual item</h3>
              <div style={styles.summaryRow}>
                <span>Items</span>
                <span>{cart.length}</span>
              </div>

              <div style={styles.summaryRow}>
                <span>Total</span>

                <span style={styles.totalPrice}>
                  ₹{total.toFixed(2)}
                </span>
              </div>

              <button
                style={styles.checkoutBtn}
                disabled={loading}
                onClick={placeOrder}
              >
                {loading
                  ? "Placing Order..."
                  : "✅ Order Request on WhatsApp"}
              </button>

              <button
                style={styles.clearBtn}
                onClick={clearCart}
              >
                Clear Cart
              </button>

            </div>

          </div>
        )}

      </div>

    </div>
  );
};

export default CartPage;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    minHeight: "100vh",
    background: "#f4f6fb",
    paddingBottom: 40
  },

  container: {
  maxWidth: 1200,
  margin: "0 auto",
  padding: "10px",
  width: "100%",
  boxSizing: "border-box"
},

  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 15,
    marginBottom: 25
  },

  title: {
    margin: 0,
    fontSize: 32,
    fontWeight: 800,
    color: "#111"
  },

  subtitle: {
    marginTop: 6,
    color: "#666",
    fontSize: 14
  },

  shopBtn: {
    background: "#111",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: 10,
    cursor: "pointer",
    fontWeight: 600
  },

  emptyBox: {
    background: "#fff",
    padding: 50,
    borderRadius: 16,
    textAlign: "center",
    boxShadow: "0 4px 15px rgba(0,0,0,0.06)"
  },

  primaryBtn: {
    marginTop: 20,
    background: "#ff9800",
    color: "#fff",
    border: "none",
    padding: "12px 20px",
    borderRadius: 10,
    cursor: "pointer",
    fontWeight: "bold"
  },

  layout: {
  display: "grid",
  gap: 25,
  width: "100%"
},

  left: {
    display: "flex",
    flexDirection: "column",
    gap: 16
  },

  card: {
    background: "#fff",
    borderRadius: 14,
    padding: 16,
    display: "flex",
    alignItems: "center",
    gap: 18,
    boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
    transition: "0.2s"
  },

  imageWrap: {
    width: 90,
    height: 90,
    borderRadius: 10,
    overflow: "hidden",
    background: "#f5f5f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },

  noImage: {
    fontSize: 12,
    color: "#777"
  },

  info: {
    flex: 1
  },

  productName: {
    margin: 0,
    fontSize: 16,
    fontWeight: 700,
    color: "#222"
  },

  price: {
    fontSize: 18,
    fontWeight: 800,
    color: "#ff5722",
    marginTop: 6
  },

  qtyWrap: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginTop: 10
  },

  qtyBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    border: "none",
    background: "#ff9800",
    color: "#fff",
    fontSize: 18,
    cursor: "pointer"
  },

  qtyText: {
    fontWeight: "bold",
    minWidth: 25,
    textAlign: "center"
  },

  rightBox: {
    textAlign: "right",
    minWidth: 110
  },

  subtotal: {
    fontSize: 18,
    fontWeight: 800,
    color: "#111",
    marginBottom: 8
  },

  removeBtn: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600
  },

  summary: {
  background: "#fff",
  padding: 20,
  borderRadius: 16,
  boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
  width: "100%",
  boxSizing: "border-box"
},

  summaryTitle: {
    marginTop: 0,
    marginBottom: 18,
    fontSize: 20,
    fontWeight: 800
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 12,
    fontSize: 15,
    color: "#333"
  },

  totalPrice: {
    fontWeight: 900,
    color: "#ff5722",
    fontSize: 20
  },

  checkoutBtn: {
  width: "100%",
  background: "#28a745",
  color: "#fff",
  border: "none",
  padding: "14px 10px",
  borderRadius: 12,
  cursor: "pointer",
  fontSize: 14,
  fontWeight: "bold",
  marginTop: 15,
  whiteSpace: "normal",
  wordBreak: "break-word"
},

  clearBtn: {
    width: "100%",
    background: "#dc3545",
    color: "#fff",
    border: "none",
    padding: 12,
    borderRadius: 12,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: "bold",
    marginTop: 10
  }
};